import { render, staticRenderFns } from "./ConferenceCommittees.vue?vue&type=template&id=dea72142&scoped=true&"
import script from "./ConferenceCommittees.vue?vue&type=script&lang=js&"
export * from "./ConferenceCommittees.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceCommittees.vue?vue&type=style&index=0&id=dea72142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea72142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressLinear})
